<template>
  <div class="input-range-wrapper">
    <input
      type="range"
      :value="modelValue"
      v-bind="props"
      @input="handleInputChange"
      list="graduations"
      :style="`--custom-color: ${color}; --progress:
  ${((modelValue - min) * 100) / (max - min)}%`"
    />
    <div class="ticks">
      <span
        v-for="tick in max / indicatorStep + 1"
        :key="tick"
        v-text="(tick - 1) * indicatorStep"
      />
    </div>
  </div>
</template>

<script setup>
const emits = defineEmits(["update:modelValue"]);

const props = defineProps({
  modelValue: {
    type: Number,
    required: true,
  },
  min: {
    type: Number,
    default: 0,
  },
  max: {
    type: Number,
    default: 100,
  },
  step: {
    type: Number,
    default: 1,
  },
  indicatorStep: {
    type: Number,
    default: 1,
  },
  color: {
    type: String,
  },
});

function handleInputChange(e) {
  let target = e.target;
  const min = target.min;
  const max = target.max;
  const val = target.value;

  target.style.backgroundSize = ((val - min) * 100) / (max - min) + "% 100%";

  emits("update:modelValue", parseInt(e.target.value));
}
</script>
